// extracted by mini-css-extract-plugin
export default {"App":"App_App__7KklW","mainContent":"App_mainContent__WToP4","arrow_up":"App_arrow_up__ySv4h","ttr":"App_ttr__n1Gz9","ru":"App_ru__Sprud"};